// extracted by mini-css-extract-plugin
export default {"section":"vs-z","inSectionButton":"ws-z","addressCard":"xs-z","disabled":"ys-z","cautionBox":"zs-z","failureBox":"As-z","fade-out":"Bs-z","successBox":"Cs-z"};